import React, { useCallback, useEffect, useRef, useState } from "react";
import bg from "../../assets/images/ERIC.png";
import MenuIcon from "@mui/icons-material/Menu";
import "./HomePage.scss";
import {
  IconButton,
  Menu,
  MenuItem,
  Paper,
  alpha,
  styled,
} from "@mui/material";
import {
  ArrowCircleDown,
  ArrowCircleUp,
  Cancel,
  CancelOutlined,
  Close,
} from "@mui/icons-material";
import defaultProfile from "../../assets/images/defaultProfile.png";
import profile1 from "../../assets/images/profile1.jpg";
import profile2 from "../../assets/images/profile2.jpg";
import qingge from "../../assets/images/qingge.jpg";
import Richard from "../../assets/images/Richard.jpg";
import jordan from "../../assets/images/jordan.jpg";
import justin from "../../assets/images/justin.JPG";
import kushal from "../../assets/images/kushal.jpg";
import Maxwell from "../../assets/images/Maxwell.JPG";
import kaylan from "../../assets/images/kaylan.jpg";
import Yimer from "../../assets/images/Yimer.jpg";
const menuItem = [
  "Home",
  "News",
  "Research",
  "Publications",
  "Software",
  "Teaching",
  "People",
  "About PI",
  "Positions",
];

const publications = [
  
  

];

const teachings = [
  "COMP 385 Theory of Computing, Fall 2024",
  "COMP 496 Senior Project II, Fall 2024",
  "COMP 841 Deep Learning, Spring 2024",
  "COMP 496 Senior Project II, Fall 2023", "COMP 385 Theory of Computing, Fall 2023",
  "COMP 841 Deep Learning, Spring 2023",
  "COMP 385 Theory of Computing, Fall 2022",
  "COMP 496 Senior Project II, Fall 2022",
  "COMP 496 Senior Project II, Spring 2022",
  "COMP 841 Deap Learning, Spring 2022",
  "COMP 285 Analysis of Algorithms, Fall 2021",
  "COMP 496 Senior Project II, Fall 2021",
  "COMP 841 Deep Learning, Spring 2021",
  "COMP 496 Senior Project II, Spring 2021",
  "COMP 496 Senior Project II, Fall 2020",
];

const people = [
  {
    name: "Dr. Richard Annan, Fall 2022 - Spring 2026",
    qualification: "Currently a Data Science Engineer at Qorvo",
    description: `His research focuses on using deep learning techniques
     for genetic predictions. He is also a certified Project Management Professional (PMP) with 
     experience in end-to-end management of projects both in academia and industry. He recently pubshlished papers
     at Journal of Computational Biology, ACM BCB'24, IEEE HealthCom'24, BICOB'24, ISBRA'23 and BIBE'23 at my lab.`,
    img: Richard,
  },
  {
    name: "Mr. Maxwell Sam, Spring 2025",
    qualification: "PhD student at NCAT",
    description: `He obtained his Master's degree in computer science from NCAT in Fall 2024. He is a dedicated backend engineer with over three years of experience in the dynamic realm of software development. 
    His focus has been on crafting robust backend solutions, ensuring seamless and secure functionality for a wide range of applications.
    Now, He is pursuing his master's in Computer Science with a specialized focus on Artificial Intelligence and Deep Learning. His publications at my lab include IEEE HealthCom 2024, Pervasive and Mobile Computing Journal (Elsevier), IEEE UEMCON 2024 and IEA/AIE 2024.`,
    img: Maxwell,
  },
  {
    name: "Mr. Hailemicael Lulseged Yimer, Spring 2025",
    qualification: "PhD student at NCAT",
    description: `His research focuses on ML, computer vision, deep learning, visual language models, and generative AI, with a particular emphasis on creating accessible and interpretable technologies that address real-world challenges.
Drawing from his expertise in deep learning and computer vision, his work spans various domains including model optimization and implementation of advanced visualization techniques for enhanced interpretability. His research combines technical innovation with a strong commitment to ethical considerations and human values.
Passionate about ethical AI development, his research interests extend to explainable AI and multimodal systems.`,
    img: Yimer,
  },
  {
    name: "Mr. Kushal Kalyan, Fall 2023 - Spring 2025",
    qualification: "Currently working at Apex Analytix",
    description: `He is currently a Master student at NCAT, starting from Fall 2023. He has 4.5 years
    of experience as a skilled front-end web develper. He is passionate about full stack development,
    machine learng and deep learning. His publications at my lab include Pervasive and Mobile Computing Journal (Elsevier), IEEE UEMCON 2024 and IEA/AIE 2024.`,
    img: kaylan,
  },
  {
    name: "Ms. Alexis Cathcart, Fall 2023",
    qualification: "Master student at NCAT",
    description: `Alexis Cathcart completed her 
    Bachelor's in Computer Science at North Carolina A&T State University in May 2023. Her research interests 
    include artificial intelligence, machine learning, data science, and bioinformatics. `,
    img: profile1,
  },
  {
    name: "Mr. Maxwell Sam, Fall 2023",
    qualification: "Master student at NCAT, graduated in Fall 2024.",
    description: `Thesis Title: Explainable Convolution Neural Network for COVID-19 Detection and Phenotype Prediction. He is a dedicated backend engineer with over three years of experience in the dynamic realm of software development. 
    His focus has been on crafting robust backend solutions, ensuring seamless and secure functionality for a wide range of applications.
    Now, He is pursuing his master's in Computer Science with a specialized focus on Artificial Intelligence and Deep Learning. His publications at my lab include IEEE HealthCom 2024, Pervasive and Mobile Computing Journal (Elsevier), IEEE UEMCON 2024 and IEA/AIE 2024.`,
    img: Maxwell,
  },
  {
    name: "Mr. Kushal Badal, Fall 2023",
    qualification: "Master student at NCAT, graduated in Fall 2024.",
    description: `Thesis Title: Solving Protein Scaffold Filling Problem with Probabilistic Algorithm and Machine Learning. His research interests are AI and data science. 
    He gained practical experience in data analysis, machine learning, and research, complemented by leadership roles and a commitment to continuous learning. 
    His goal is to leverage his technical skills and enthusiasm for problem-solving to make meaningful contributions in the field of AI. His publications at my lab include ISBRA 2024 and Journal of Computational Biology.`,
    img: kushal,
  },
  {
    name: "Mr. Jordan Sturtz, Fall 2021",
    qualification: "Master student at NCAT, graduated in May 2023",
    description: `Thesis Title: Deep Learning Approaches for the Protein Scaffold Filling Problem.
    During his Master study at my lab, Jordan published the papers at IEEE Transactions on Sustainable Computing, Pervasive and Mobile Computing Journal (Elsevier), Mathematics, Journal of Computational Biology, ISBRA'23, IEEE SMARTCOMP'23 and IEEE ICTAI'22. `,
    img: jordan,
  },
  {
    name: "Mr. Justin Noland, Fall 2021",
    qualification: "Master student at NCAT, graduated in July 2023",
    description: `Thesis: A Privacy Preserving Convolutional Neural Network for Phenotype Prediction.`,
    img: justin,
  },
];

const aboutPI = {
  name: "Dr. Letu Qingge",
  designation: "Associate Professor",
  college: "North Carolina A&T State University",
  department: "Department of Computer Science",
  description: `Dr. Letu Qingge is a director of BioAI lab at NCAT. He received his Ph.D degree in Computer Science 
   from Montana State University, MT, USA. His research interests include algorithms and combinatorial optimization,
   machine learning and deep learning,  bioinformatics and computational biology, image processing and
   computer vision. His papers received ISBRA 2024 Best Paper Award, BICOB 2024 Best Paper Award Finalist and IEEE UEMCON 2023 Best Paper Award. His research has been funded by NSF and NIH. He is a recipient of 2024-2025 Academic Advising Excellence Award (Faculty) for the College of Engineering and 2025 Advisor to the Recipient of the Outstanding Thesis Award at North Carolina A&T State University.`,
  img: qingge,
};

const StyledMenu = styled((props) => (
  <Menu
    disableScrollLock={true}
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: "12rem",
    backgroundColor: "rgba(0,0,0,0.8)",
    color: "#fff",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
      color: "#fff",
    },
    "& .MuiMenuItem-root": {
      "&:active": {
        background: "#fff",
        color: "#000",
      },
    },
  },
}));

const HomePage = () => {
  const pageRef = useRef(null);
  const [isRotate, setIsRotate] = useState(false);
  const [changeMenuIcon, setChangeMenuIcon] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeNav, setActiveNav] = useState("Home");
  const open = Boolean(anchorEl);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (pageRef?.current) {
      pageRef.current.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  }, [activeNav]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setIsRotate(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setChangeMenuIcon(!changeMenuIcon);
    }, 600);
  }, [isRotate]);

  return (
    <div
      ref={scrollRef}
      onScroll={(e) => {
        console.log(e);
      }}
      style={{ position: "relative" }}
    >
      <ArrowCircleUp
        htmlColor="rgba(0,0,0,0.8)"
        style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          fontSize: "2rem",
          margin: "0.8rem",
          cursor: "pointer",
        }}
        onClick={() => setActiveNav("Home")}
      />
      <div
        id="Home"
        ref={activeNav === "Home" ? pageRef : null}
        className="homePage-main"
        style={{
          height: "100vh",
          flex: 1,
          display: "flex",
          backgroundImage: `url(${bg})`,
          backgroundSize: "auto 120vh",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          justifyContent: "center",
          alignItems: "center",
          animation: "zoomInOut ease 8s infinite alternate",
          position: "relative",
        }}
      >
        <ArrowCircleDown
          htmlColor="rgba(255,255,255,0.4)"
          style={{
            position: "absolute",
            bottom: "20px",
            fontSize: "2rem",
            animation: "scrollDownIndicator ease 1s infinite",
          }}
        />
        <div
          style={{
            textAlign: "center",
            animation: "fadeIn ease 10s",
            animationFillMode: "forwards",
          }}
        >
          <div
            style={{
              fontSize: "4.5rem",
              fontWeight: "bolder",
              color: "#fff",
              animation: "leftToRight ease 5s",
              animationFillMode: "forwards",
            }}
          >
            Bioinformatics and Artificial Intelligence Lab (BioAI Lab)
          </div>
          <div
            style={{
              fontWeight: 500,
              color: "#fff",
              animation: "rightToLeft ease 5s",
              animationFillMode: "forwards",
            }}
          >
            PI: Dr. Letu Qingge
          </div>
        </div>
        <IconButton
          id="basic-button"
          style={{
            zIndex: 9999,
            position: "fixed",
            top: 0,
            right: 0,
            margin: "0.8rem",
            animation: isRotate
              ? "rotateRight ease 0.5s"
              : "rotateLeft ease 0.5s",
            animationFillMode: "forwards",
            backgroundColor: "rgba(0,0,0,0.5)",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px !important",
          }}
          onClick={(e) => {
            setIsRotate(!isRotate);

            changeMenuIcon ? handleClick(e) : handleClose();
          }}
        >
          {changeMenuIcon || changeMenuIcon === null ? (
            <MenuIcon htmlColor="#fff" style={{ fontSize: "1.2rem" }} />
          ) : (
            <Close htmlColor="#fff" style={{ fontSize: "1.2rem" }} />
          )}
        </IconButton>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          {menuItem?.map((item, i) => (
            <MenuItem
              key={i}
              selected={item === activeNav}
              onClick={() => {
                handleClose();
                setActiveNav(item);
              }}
              href={item}
            >
              {item}
            </MenuItem>
          ))}
        </StyledMenu>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="News"
        ref={activeNav === "News" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          News
        </div>
        <ul>
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Badal won the University 2025 Outstanding Thesis Award, Spring 2025.
            </li>
          ))}
           {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Badal won the College of Engineering 2025 Outstanding Thesis Award, Spring 2025.
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Badal won the Computer Science Department 2025 Outstanding Thesis Award, Spring 2025.
            </li>
          ))}
            {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Richard Annan received a finalist for the University 2025 Doctoral Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Richard Annan won the College of Engineering 2025 Doctoral Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Richard Annan won the Computer Science Department 2025 Doctoral Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
           {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Kalyan Devalampeta Surendranath won the Computer Science Department 2025  Master's Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
            {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Richard Annan won the Computer Science Department 2025 Outstanding Senior Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
           {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Maxwell Sam won the Computer Science Department 2025 Outstanding Junior Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
           {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Kalyan Devalampeta Surendranath won the Computer Science Department 2025 Outstanding Junior Graduate Research Assistant Award, Spring 2025.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >We successfully organized a university-wide ExpandAI workshop at NCAT in November 2024. Detailed information can be found from this website. https://kushal-1234.github.io/nsf-research-website/#/
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Maxwell Sam passed his final thesis defense. November 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Kushal Badal passed his final thesis defense. October 2024.
            </li>
          ))}
      
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Our paper was accepted by ACM BCB 2024, September 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Our paper was published at Pervasive and Mobile Computing Journal (PMC), ELSEVIER! IF:3.0 August 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Our paper received Best Paper Award at ISBRA 2024! July 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! Master student Kushal Badal passed his proposal defense! April 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Congratulations! PhD student Richard Annan received 2024 Outstanding Senior Graduate Research Assistant Award, Spring 2024.
            </li>
          ))}

{[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            > Congratulations! Master student Maxwell Sam received 2024 Outstanding Junior Graduate Research Assistant Award, Spring 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >Richard Annan passed the PhD qualifying exam! Congratulations! March, 2024.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Two papers were accepted at the 37th International Conference on Industrial, Engineering & Other Applications of Applied Intelligent Systems (IEA/AIE 2024), Hradec Kralove, Czech Republic.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper was accepted at IEEE International Conference on Multimedia and Expo (IEEE ICME 2024), Niagra Falls, Canada.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper received Best Paper Award  Finalist at 16th International Conference on Bioinformatics and Computational Biology (BICOB'24), New Orleans, LA.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "Parallel Trajectory Training of Recurrent Neural Network Controllers with Levenberg-Marquardt and Forward Accumulation Through Time in Closed-loop Control Systems" was published by the IEEE Transactions on Sustainable Computing, 2023. IF: 3.9.
            </li>
          ))}
        {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "Machine Learning Models for Phenotype Prediction from Genotype" was accepted by the 23rd IEEE International Conference on Bioinformatics and Bioengineering (BIBE) 2023. 
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "Accelerating FPGA Implementation of Neural Network Controllers via 32-bit Fixed-Point Design for Real-Time Control" was accepted by the IEEE UEMCON 2023, New York.  This paper was awarded the BEST PAPER at IEEE UEMCON 2023.
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "A Convolutional Denoising Autoencoder for Protein Scaffold Filling" was accepted by the 19th International Symposium on Bioinformatics Research and Applications (ISBRA 2023), Wroclaw, Poland, August 2023.
            </li>
          ))}
           {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "A Novel Weight Dropout Approach to Accelerate the Neural Network Controller Embedded Implementation on FPGA for a Solar Inverter " was recently published at IEEE SMARTCOMP 2023, Nashville, TN. 
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Our paper titled "PMT-IQA: Progressive Multi-task Learning for Blind Image Quality Assessment" was accepted by the 20th 
              Pacific Rim International Conference on Artificial Intelligence (PRICAI), Jakarta, Indonesia, August 2023. 
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Justin Noland successfully defended his Master thesis in June, 2023.
            </li>
          ))}
          {[1].map((i) => (
            <li
              key={i}
              style={{
                paddingBottom: "1rem",
              }}
            >
              Jordan Sturtz successfully defended his Master thesis in May, 2023.
            </li>
          ))}
        </ul>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="Research"
        ref={activeNav === "Research" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          Research
        </div>
        <ul>
        {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Algorithms and Combinatorial Optimization
            </li>
          ))}
        {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Machine Learning and Deep Learning
            </li>
          ))}
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Bioinformatics and Computational Biology
            </li>
          ))}
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Image Processing and Computer Vision 
            </li>
          ))}
           {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Cloud Computing and Parallel Computing
            </li>
          ))}
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Neural Network Control and Renewable Eenergy
            </li>
          ))}
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Transportation Network and Smart Transportation
            </li>
          ))}
        </ul>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
          display: "flex",
          flexDirection: "column",
        }}
        id="Publications"
        ref={activeNav === "Publications" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          Publications
        </div>
        <ul>
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              <a href="https://scholar.google.com/citations?user=-D7jAYEAAAAJ&hl=en&oi=ao">My Google Scholar Page</a>
            </li>
          ))}
        </ul>
        {publications.map((item, i) => (
          <div
            key={i}
            style={{
              margin: "1rem 0 2rem 0",
              padding: "1.5rem",
              backgroundColor: i % 2 === 0 ? "lightblue" : "antiquewhite",
              borderRadius: "20px",
              fontSize: "1.1rem",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              maxWidth: "50rem",
              minWidth: "50rem",
              display: "flex",
              flexDirection: "column",
              alignSelf: i % 2 === 0 ? "flex-start" : "flex-end",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{item.title}</span>
              <span
                style={{
                  padding: "0rem 1rem",
                  backgroundColor: i % 2 !== 0 ? "lightblue" : "antiquewhite",
                  borderRadius: "4px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  fontSize: "1rem",
                }}
              >
                {item.year}
              </span>
            </div>
            <div>{item.publishers}</div>
            <div>{item.descriptions}</div>
          </div>
        ))}
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="Software"
        ref={activeNav === "Software" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          Software
        </div>
        <ul>
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
               <a href="http://psf.ncat.edu/ ">The Protein Scaffold Filler Web Application</a> 
            </li>
          ))}
        </ul>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
          display: "flex",
          flexDirection: "column",
        }}
        id="Teaching"
        ref={activeNav === "Teaching" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          Teaching
        </div>
        <div
          style={{
            margin: "1rem 0 2rem 0",
            display:"flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {teachings.map((item, i) => (
            <div
              key={i}
              style={{
                margin: "1rem 1rem 2rem 1rem",
                padding: "1rem",
                backgroundColor: "antiquewhite",
                borderRadius: "20px",
                fontSize: "1.1rem",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                display: "flex",
                flexDirection: "row",
                fontWeight: "500",
                fontSize: "1.1rem",
                width: "fit-content",
                minWidth: "400px",
                maxWidth: "400px",
                justifyContent: "space-between",
                alignItems:"center",
                position:"relative",
              }}
            >
              {item.split(",")[0]}{" "}
              <span
                style={{
                  marginLeft: "2rem",
                  padding: "0rem 1rem",
                  backgroundColor: "lightblue",
                  borderRadius: "4px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  fontSize: "1rem",
                  whiteSpace: "nowrap",
                  width: "fit-content",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {item.split(",")[1]}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="People"
        ref={activeNav === "People" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          People
        </div>
        {people.map((item, i) => (
          <div
            key={i}
            style={{
              margin: "1rem 0 2rem 0",
              padding: "1.5rem",
              backgroundColor: i % 2 === 0 ? "lightblue" : "antiquewhite",
              borderRadius: "20px",
              fontSize: "1.1rem",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                height: "10rem",
                width: "10rem",
                marginRight: "1.5rem",
              }}
            >
              <img
                src={item?.img ? item?.img : defaultProfile}
                style={{ height: "10rem", borderRadius: "4px" }}
              />
            </div>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                }}
              >
                <span>{item.name}</span>
                <span
                  style={{
                    padding: "0.2rem 1rem",
                    backgroundColor: i % 2 !== 0 ? "lightblue" : "antiquewhite",
                    borderRadius: "4px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    fontSize: "0.9rem",
                  }}
                >
                  {item.qualification}
                </span>
              </div>
              <div>{item.description}</div>
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="About PI"
        ref={activeNav === "About PI" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          About PI
        </div>
        <div
          style={{
            margin: "1rem 0 2rem 0",
            padding: "1.5rem",
            backgroundColor: "lightblue",
            borderRadius: "20px",
            fontSize: "1.1rem",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              height: "15rem",
              width: "15rem",
              marginRight: "1.5rem",
            }}
          >
            <img
              src={aboutPI?.img ? aboutPI?.img : defaultProfile}
              style={{ height: "15rem", borderRadius: "4px" }}
            />
          </div>
          <div style={{ width: "100%" }}>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "1.6rem", color: "#000" }}>
                {aboutPI.name}
              </span>
              <span
                style={{
                  padding: "0.2rem 1rem",
                  backgroundColor: "antiquewhite",
                  borderRadius: "4px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  fontSize: "0.9rem",
                }}
              >
                {aboutPI.designation}
              </span>
            </div>
            <div style={{ fontSize: "1rem" }}>{aboutPI.college}</div>
            <div style={{ fontSize: "1rem" }}>{aboutPI.department}</div>
            <div style={{ fontSize: "1rem", marginTop: "0.5rem" }}>
              <span style={{ fontWeight: "bold" }}> </span>
              {aboutPI.education}
            </div>
            <div style={{ fontSize: "1rem", marginTop: "0.5rem" }}>
              <span style={{ fontWeight: "bold" }}>About: </span>
              {aboutPI.description}
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          padding: "2rem 10rem",
        }}
        id="Positions"
        ref={activeNav === "Positions" ? pageRef : null}
      >
        <div style={{ fontSize: "1.8rem", fontWeight: "bold", padding: "0" }}>
          Positions
        </div>
        <ul>
          {[1].map((i) => (
            <li key={i} style={{ paddingBottom: "1rem" }}>
              Actively looking for self-motivated Ph.D. students who are interested in the area of algorithms, machine learning, deep learning and 
              has a strong Python/C++ programming skills and math background. The candidates with a BS or MS in computer science are preferrable. 
              Industrial experience and many years of hands-on programming/software development are a plus. If you are interested, please reach out to me at lqingge at ncat dot edu.
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HomePage;
